import { render } from "./ManagerApp.vue?vue&type=template&id=13e0babe"
import script from "./ManagerApp.vue?vue&type=script&lang=js"
export * from "./ManagerApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__